import { ApiResponse } from './../models/api-response.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Dropdown } from './../models/dropdown.model';

@Injectable()
export class MemberBankHttpService {

  constructor(private http: HttpClient) { }

  getMemberBanks(): Observable<Dropdown[]> {
    return this.http.get<ApiResponse>(`/bankaccount`).pipe(
      map(res => res.data.rows)
    );
  }

}
